import React from 'react'
import SeoPage from '../components/SeoPage'

import Img from '../components/Image'
import { graphql, Link } from 'gatsby'

const ContentPage = ({ data, location, ...props }) => {
    return (
        <SeoPage
            leadImage={data.img0.childImageSharp.fluid.src}
            location={location}
            title="Avocat pour Conduite avec facultés affaiblies par la drogue ou l'alcool"
            description="Si vous êtes interceptés au volant d’un véhicule avec des facultés affaiblies, il est fort probable qu’un avocat puisse vous venir en aide. Avocats Alcool au Volant vous permet de trouver le professionnel qu’il vous faut gratuitement!"
            fr={undefined}
            lawType="criminal"
            specialtyText="spécialisé en alcool au volant">
            <p>
                Peu importe la raison, la conduite avec les facultés affaiblies
                vient avec de lourdes conséquences. Toutefois, avant d’être
                reconnu coupable, l’aide d’un avocat peut vous être grandement
                utile.{' '}
            </p>
            <p>
                En plus de vous représenter lors du procès, l’avocat spécialisé
                en conduites avec facultés affaiblies pourra:
            </p>
            <ul>
                <li>Négocier un plaidoyer de culpabilité,</li>
                <li>
                    Présenter des{' '}
                    <Link to="https://avocatsalcoolauvolant.ca/defenses-alcool-volant/">
                        moyens de défense
                    </Link>
                    , et{' '}
                </li>
                <li>S’assurer que vos droits soient respectés. </li>
            </ul>
            <p>
                <Img
                    fluid={data.img0.childImageSharp.fluid}
                    title="Qu’est-ce que l’infraction de conduite avec les facultés affaiblies?"
                    alt=""
                />
            </p>
            <p>
                Dans bien des cas, l’aide d’un avocat peut faire toute la
                différence dans des procédures judiciaires.
            </p>
            <p>
                <strong>
                    Avocats Alcool au Volant vous explique à quoi sert un avocat
                    spécialisé en conduite avec les facultés affaiblies.{' '}
                </strong>
            </p>
            <h2>
                <strong>
                    Quelles sont les conséquences de la conduite avec les
                    facultés affaiblies?
                </strong>
            </h2>
            <p>
                Si vous êtes intercepté au volant d’un véhicule avec les
                facultés affaiblies, vous ferez face à plusieurs conséquences
                qui varient selon votre taux d’alcool et s’il s’agit de votre
                première fois ou non.{' '}
            </p>
            <p>
                Dans tous les cas, vous aurez une suspension de votre permis de
                conduire pour une durée de 90 jours, un casier judiciaire et une
                contravention d’au moins 1 000 $. En revanche, si vous avez un
                taux d’alcool d’au moins 0.16, votre véhicule sera également
                saisi, et ce, avant même de comparaître devant un juge.
            </p>
            <p>
                En ce qui concerne la <strong>peine d’emprisonnement</strong>,
                celle-ci n’est pas obligatoire lors d’une première infraction.
                En revanche, dès votre deuxième infraction d’alcool au volant,
                celle-ci devient inévitable.{' '}
            </p>
            <table>
                <tr>
                    <td>
                        <p>Infraction</p>
                    </td>
                    <td>
                        <p>Peine minimale</p>
                    </td>
                    <td>
                        <p>Peine maximale</p>
                    </td>
                </tr>
                <tr>
                    <td>
                        <p>Première</p>
                    </td>
                    <td>
                        <p>Amende de 1 000$</p>
                    </td>
                    <td>
                        <p>10 ans d’emprisonnement</p>
                    </td>
                </tr>
                <tr>
                    <td>
                        <p>Deuxième</p>
                    </td>
                    <td>
                        <p>30 jours d’emprisonnement</p>
                    </td>
                    <td>
                        <p>10 ans d’emprisonnement</p>
                    </td>
                </tr>
                <tr>
                    <td>
                        <p>Troisième</p>
                    </td>
                    <td>
                        <p>120 jours d’emprisonnement</p>
                    </td>
                    <td>
                        <p>10 ans d’emprisonnement</p>
                    </td>
                </tr>
            </table>
            <p>
                Évidemment, même si vous en êtes à votre première infraction, il
                peut exister des circonstances aggravantes (un taux d’alcool de
                0.16 par exemple).{' '}
            </p>
            <p>
                Si vos facultés affaiblies causent des lésions corporelles, vous
                pourriez, en cas de mise en accusation, avoir une peine
                d’emprisonnement d’une durée maximale de 14 ans. Si vous avez
                causé la mort, la peine pourrait alors être à perpétuité.
            </p>
            <h2>
                <strong>Qu’en est-il du taux d’alcool interdit?</strong>
            </h2>
            <p>
                Bien que la conduite avec les facultés affaiblies n'impose pas
                un taux minimal, il existe des limites criminelles pour
                plusieurs substances, notamment l’alcool, le cannabis et
                d’autres drogues.{' '}
            </p>
            <p>
                <Img
                    fluid={data.img1.childImageSharp.fluid}
                    title="Quel est le taux d’alcoolémie interdit au Québec?"
                    alt=""
                />
            </p>
            <p>
                Pour être reconnu coupable, les tests doivent être effectués
                dans les <strong>deux heures </strong>qui suivent le moment où
                vous avez pris le volant. En ce qui concerne le taux d’alcool,
                vous avez l’interdiction de conduire si votre taux est d’au
                moins 80 mg d’alcool par 100 ml de sang.{' '}
            </p>
            <p>
                En ce qui concerne la consommation de cannabis, il faudra
                s'assurer que votre taux de THC soit inférieur à 2 ng par ml de
                sang. Si vous avez un taux supérieur à 5 ng, les sanctions
                seront plus importantes.{' '}
            </p>
            <table>
                <tr>
                    <td>
                        <p>Infraction</p>
                    </td>
                    <td>
                        <p>Concentration de THC</p>
                    </td>
                </tr>
                <tr>
                    <td>
                        <p>Moins grave</p>
                    </td>
                    <td>
                        <p>Entre 2 ng et 5 ng de THC par ml de sang</p>
                    </td>
                </tr>
                <tr>
                    <td>
                        <p>Plus grave</p>
                    </td>
                    <td>
                        <p>Au moins 5 ng de THC par ml de sang</p>
                    </td>
                </tr>
            </table>
            <p>
                Le Code criminel a également des limites si vous consommez à la
                fois de l’alcool et du cannabis. Ce taux est d’au moins 50 mg
                d’alcool par 100 ml de sang et au moins 2,5 g de THC par ml de
                sang.
            </p>
            <p>
                En ce qui concerne les autres drogues, il y a une tolérance zéro
                sur la consommation. Cela est particulièrement vrai si vous
                prenez le volant.{' '}
            </p>
            <p>
                <strong>Le saviez-vous? </strong>Votre corps produit
                naturellement une petite concentration de GHB. Ainsi, il y a une
                tolérance pour une concentration inférieure à 5 mg par litre de
                sang.{' '}
            </p>
            <h2>
                <strong>
                    Conduite avec les facultés affaiblies – Quelles sont les
                    sanctions administratives?
                </strong>
            </h2>
            <p>
                Avant même d’être reconnu coupable par un juge, le policier qui
                vous interceptera au volant d’un véhicule pourra suspendre votre
                permis. D’autres conséquences pourront vous être imposées selon
                votre situation.{' '}
            </p>
            <h3></h3>
            <h3>
                <strong>La première infraction</strong>
            </h3>
            <p>
                Votre permis de conduire sera, dès votre arrestation, suspendu
                pour une <strong>période entre 24 heures et 90 jours. </strong>
                De plus, votre véhicule peut être saisi immédiatement, et ce,
                pour 30 jours.
            </p>
            <p>
                <Img
                    fluid={data.img2.childImageSharp.fluid}
                    title="Quelles sont les sanctions administratives de la conduite avec facultés affaiblies?"
                    alt=""
                />
            </p>
            <p>
                Dès que vous serez reconnu coupable d’avoir commis une telle
                infraction, vous aurez l’interdiction de conduire pour au moins
                1 an. Votre permis sera également révoqué pour une durée qui est
                généralement entre 1 et 3 ans.
            </p>
            <p>
                Dans certains cas, il est possible que le juge vous oblige à
                respecter l’une des obligations suivantes:
            </p>
            <ul>
                <li>Programme Alcofrein,</li>
                <li>
                    Programme d’évaluation et de réduction du risque de conduite
                    avec les capacités affaiblies, et
                </li>
                <li>Antidémarreur.</li>
            </ul>
            <p>
                Pour une première infraction, la contravention est de 1 000 $.
                Cependant, il faut ajouter plusieurs autres frais, notamment:
            </p>
            <ul>
                <li>Les honoraires d’avocat, </li>
                <li>L’augmentation de votre prime d’assurance, </li>
                <li>
                    Vos contributions au régime d’indemnisation des victimes
                    d’actes criminels (IVAC), et{' '}
                </li>
                <li>les frais de casier judiciaire. </li>
            </ul>
            <h3>
                <strong>La deuxième infraction</strong>
            </h3>
            <p>
                Si vous êtes intercepté pour une deuxième fois au volant d’un
                véhicule avec des facultés affaiblies dans les 10 ans qui
                suivent votre première infraction, d’autres sanctions seront
                prises.
            </p>
            <p>
                Votre véhicule sera saisi pour une durée d’environ 90 jours. Le
                policier peut vous contraindre à suivre le Programme
                d’évaluation et de réduction du risque de conduite avec les
                capacités affaiblies.
            </p>
            <p>
                Après la déclaration de culpabilité, vous aurez l’interdiction
                de conduire votre véhicule{' '}
                <strong>pour au moins 2 ans. </strong>Votre permis sera révoqué
                pour une durée qui varie entre 3 et 5 ans. Cela vient avec une
                interdiction d’immatriculer ou d’acquérir un véhicule en votre
                nom.
            </p>
            <h3>
                <strong>La troisième infraction</strong>
            </h3>
            <p>
                Finalement, si vous en êtes à votre deuxième récidive en 10 ans,
                les conséquences administratives restent similaires à celles de
                votre première récidive. Toutefois, certaines sanctions seront
                obligatoires et non pas facultatives.
            </p>
            <p>
                <Img
                    fluid={data.img3.childImageSharp.fluid}
                    title="Quelles sont les conséquences d’une récidive de conduite avec facultés affaiblies?"
                    alt=""
                />
            </p>
            <p>
                En effet, cela sera notamment le cas de{' '}
                <strong>l’antidémarreur à vie</strong> et de l’interdiction
                d’immatriculer, d’acquérir, de louer et de mettre en circulation
                un véhicule.
                <strong>
                    Vous souhaitez connaître les sanctions administratives
                    auxquelles vous faites face si vous avez conduit avec les
                    facultés affaiblies?
                </strong>
            </p>
            <p>
                <strong>
                    Avocats Alcool au Volant vous permet de trouver le
                    professionnel qu’il vous faut en quelques clics seulement.
                </strong>
            </p>
            <h2>
                <strong>
                    Conduite avec facultés affaiblies – À quoi sert l’avocat?
                </strong>
            </h2>
            <p>
                Vous avez récemment été intercepté au volant d’un véhicule avec
                des facultés affaiblies? Dans ce cas, il est fort probable qu’un{' '}
                <Link to="https://avocatsalcoolauvolant.ca/avocat-criminel-alcool-volant/">
                    avocat spécialisé en droit criminel{' '}
                </Link>
                vous soit d’une grande utilité.
            </p>
            <p>
                Il pourra s’assurer que vos droits sont respectés et que vous
                ayez une défense pleine et entière.
            </p>
            <p>
                <strong>
                    Heureusement, il est désormais possible de trouver l’avocat
                    qu’il vous faut en remplissant le formulaire en ligne
                    d’Avocats Alcool au Volant!
                </strong>
            </p>
        </SeoPage>
    )
}

export default ContentPage

export const pageQuery = graphql`
    query ($language: String!) {
        locales: allLocale(filter: { language: { eq: $language } }) {
            edges {
                node {
                    ns
                    data
                    language
                }
            }
        }
        img0: file(
            relativePath: {
                eq: "avocat-conduite-facultes-affaiblies/conduite-facultes-affaiblies.jpeg"
            }
        ) {
            childImageSharp {
                fluid(maxWidth: 960) {
                    ...GatsbyImageSharpFluid
                }
            }
        }
        img1: file(
            relativePath: {
                eq: "avocat-conduite-facultes-affaiblies/taux-alcoolemie-interdit.jpeg"
            }
        ) {
            childImageSharp {
                fluid(maxWidth: 960) {
                    ...GatsbyImageSharpFluid
                }
            }
        }
        img2: file(
            relativePath: {
                eq: "avocat-conduite-facultes-affaiblies/consequence-sanction-administrative.jpeg"
            }
        ) {
            childImageSharp {
                fluid(maxWidth: 960) {
                    ...GatsbyImageSharpFluid
                }
            }
        }
        img3: file(
            relativePath: {
                eq: "avocat-conduite-facultes-affaiblies/consequences-recidive-facultes-affaiblies.jpeg"
            }
        ) {
            childImageSharp {
                fluid(maxWidth: 960) {
                    ...GatsbyImageSharpFluid
                }
            }
        }
    }
`
